<i18n>
{
  "fr": {
    "read-more": "Lire plus +",
    "read-less": "Lire moins -"
  }
}
</i18n>

<template>
  <div class="collapsible">
    <div
      ref="contentWrapper"
      :class="[
        'collapsible__content',
        {
          'collapsible__content--collapsed':
            isCollapsed && !isDesktop && canExpand,
        },
      ]"
      :style="contentStyle"
    >
      <div ref="innerContent" class="collapsible__inner">
        <slot></slot>
      </div>
    </div>

    <BaseBtn
      v-if="canExpand && !isDesktop"
      class="collapsible__read-more"
      type="button"
      link
      @click="isCollapsed = !isCollapsed"
    >
      <span>{{ isCollapsed ? $t('read-more') : $t('read-less') }}</span>
    </BaseBtn>
  </div>
</template>

<script>
import BaseBtn from './BaseBtn';

export default {
  name: 'CollapsibleContent',
  components: { BaseBtn },
  props: {
    collapsedHeightRem: {
      type: Number,
      default: 4.25, // default: 72px
    },
    breakpoint: {
      type: [Number, String],
      default: 992,
    },
  },
  data() {
    return {
      isCollapsed: true,
      canExpand: false,
      fullHeight: 0,
      windowWidth: globalThis.window.innerWidth,
    };
  },
  computed: {
    isDesktop() {
      if (this.breakpoint === 'none') return false;
      return this.windowWidth >= this.breakpoint;
    },
    contentStyle() {
      if (this.isDesktop) return { maxHeight: 'none' };

      // if the content is smaller than the limit
      if (!this.canExpand) return { maxHeight: 'none' };

      return {
        maxHeight: this.isCollapsed
          ? `${this.collapsedHeightRem}rem`
          : `${this.fullHeight}px`,
      };
    },
  },
  mounted() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDimensions);
  },
  methods: {
    updateDimensions() {
      this.windowWidth = window.innerWidth;

      if (this.$refs.innerContent) {
        const rootFontSize = Number.parseFloat(
          getComputedStyle(document.documentElement).fontSize
        );
        const thresholdPx = this.collapsedHeightRem * rootFontSize;

        this.fullHeight = this.$refs.innerContent.scrollHeight;

        // canExpand if the fullHeight is greater than the collapsedHeight + around
        this.canExpand = this.fullHeight > thresholdPx + 2;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.collapsible {
  &__content {
    overflow: hidden;
    transition: max-height 0.4s ease-in-out;
    position: relative;
  }

  &__read-more {
    cursor: pointer;
    font-weight: bold;
    color: $color-blue-persian;
    font-size: 0.75rem;
  }
}
</style>
